<template>
  <!-- -->
  <div class="scroll-width mini-component-show">
    <div v-for="(item, idx) in imageList" :key="idx" class="scroll-width-item">
      <alone-image :src="item.itemImage"/>
      <alone-text-on-image :data="item"/>
    </div>
  </div>
</template>

<script>

import AloneImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneImage.vue";
import {watch} from "vue";
import AloneTextOnImage from "@/views/h5/common/sys/miniProgram/setting/component/AloneTextOnImage.vue";

export default {
  props: {
    data: {default: () => {
        return {}
      }},
  },
  name: "",
  components: {
    AloneTextOnImage,
    AloneImage
  },
  data() {
    return {
      imageList: [],
    };
  },
  created() {
    this.init();
    watch(() => this.data, () => this.init())
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.imageList = [
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
          {text: "", itemImage: "", itemColor: "", itemBackGround: "", path: "", size: ""},
        ];
      } else {
        this.imageList = this.data.componentData;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.scroll-width{
  overflow-y: hidden;
  overflow-x: auto;
  white-space: nowrap;
  .scroll-width-item{
    display: inline-block;
    margin-right: 20px;
    vertical-align: bottom;
    position: relative;
    &:last-child{
      margin-right: 0;
    }
  }
}
</style>